var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29721 7.80804C0.904315 7.4199 0.900464 6.78674 1.28861 6.39385C1.67675 6.00096 2.3099 5.99711 2.70279 6.38525L1.29721 7.80804ZM11.0815 8.81665L11.7859 9.52643L11.0815 8.81665ZM2.70279 6.38525L7.41809 11.0435L6.0125 12.4663L1.29721 7.80804L2.70279 6.38525ZM7.41809 11.0435L10.3771 8.10687L11.7859 9.52643L8.82694 12.4631L7.41809 11.0435ZM13.2001 8.11222L17.5871 12.4992L16.1729 13.9134L11.7859 9.52643L13.2001 8.11222ZM10.3771 8.10687C11.159 7.33087 12.4212 7.33326 13.2001 8.11222L11.7859 9.52643V9.52643L10.3771 8.10687ZM7.41809 11.0435L7.41809 11.0435L8.82694 12.4631C8.0484 13.2358 6.79281 13.2372 6.0125 12.4663L7.41809 11.0435Z",
    fill: "#F6475D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.457 13.7285H16.6836C17.2359 13.7285 17.6836 13.2808 17.6836 12.7285V8.50281",
    stroke: "#F6475D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLight);
export default __webpack_public_path__ + "static/media/short-light.715d097eb7f6df46c6d54bbe4cf0f770.svg";
export { ForwardRef as ReactComponent };